import { useSelector } from "react-redux"
import ShimmerScreen from "../../../../Layouts/ShimmerScreen"
import "./DiscussCommentReplyComponent.scss"
import { useEffect, useState } from "react"
import _ from "lodash"
import { CircularProgress } from "@mui/material"

const txtSetHeight = 80;

const DiscussCommentReplyComponent = ({
    parentCommentId, sendCommentData, isUploadingData
}) => {

    const authData = useSelector(state => state.user.userBroker)
    const sendCmt = useSelector(state => state.discuss.sendComment)

    const [isLoading, setIsLoading] = useState(true)
    const [commentorName, setCommentorName] = useState('')
    const [commentorAvtar, setCommentorAvtar] = useState({
        imgURL: '', altText: ''
    })
    const [commentText, setCommentText] = useState('')
    const [txtAreaHgt, setTxtAreaHgt] = useState(80)
    const [allowedChar,] = useState(200)

    useEffect(() => {
        console.log('Send CommentData', sendCmt)
        if (!_.isEmpty(sendCmt)) {
            if (sendCmt.status === 'success') {
                // fetchCommentForDiscuss()
                setCommentText('')
            }
            // dispatch(postCommentDataClear())
        }
    }, [sendCmt])

    useEffect(() => {
        console.log('Parent Comment ID', parentCommentId,authData);
        if (!_.isEmpty(authData) && authData.status === 'success') {
            const payload = authData.payload.payload;
            console.log(payload)
            setCommentorName(`${payload.firstname} ${payload.lastname}`)
            const nameIntials = (payload.firstname.substr(0, 1)) + (payload.lastname ? payload.lastname.substr(0, 1) : '')
            setCommentorAvtar({
                imgURL: payload.profile_img,
                altText: nameIntials
            })
            setIsLoading(false)
        }
    }, [authData])

    const sendComment = () => {
        if (commentText) {
            console.log(commentText, parentCommentId)
            sendCommentData(commentText, parentCommentId)
        }
    }

    return (
        <div className="discuss-reply">
            <div className="avtar-logo">
                <button className="reset-btn btn-avtar">
                    {
                        isLoading ?
                            <ShimmerScreen
                                case="circle"
                                width="3rem"
                                height="3rem"
                            />
                            :
                            commentorAvtar.imgURL ?
                                <img className="" src={commentorAvtar.imgURL} alt={commentorAvtar.altText} />
                                :
                                <div
                                    className={`title-logo d-flex justify-content-center align-items-center bk-grey cursor-pointer`}
                                >
                                    <p>{commentorAvtar.altText}</p>
                                </div>
                    }
                </button>
            </div>
            <div className="reply-input">
                <div className="reply-title d-flex gap-1 align-items-center">You
                    {
                        isLoading ?
                            <div className="d-flex gap-1">
                                (
                                <ShimmerScreen
                                    case="rect"
                                    width="2rem"
                                    height="1rem"
                                />
                                )
                            </div>
                            :
                            commentorName ?
                                <div>
                                    ({commentorName})
                                </div>
                                : ''
                    }
                </div>
                <form className="comment-form d-flex gap-1">
                    <div className="txtarea-progress position-relative">
                        <textarea
                            placeholder="Join the discussion..."
                            row="2"
                            className="reply-box"
                            style={{height: `${txtAreaHgt}px`, minHeight: `${txtSetHeight}px`}}
                            value={commentText}
                            disabled={isUploadingData}
                            onChange={(e) => {
                                console.log(e.target.value, e.target.value.length)
                                setCommentText(e.target.value)
                            }}
                            onKeyUp={(e) => {
                                const hgt = e.target.scrollHeight
                                if (hgt) {
                                    if (hgt > txtSetHeight) {
                                        setTxtAreaHgt(hgt)
                                    }
                                }
                            }}
                        />
                        {
                            isUploadingData ?
                                <button type="button" title="Send" className="send-reset-btn d-flex gap-1 align-items-center"
                                >
                                    <i className="fa fa-spinner"></i>
                                </button>
                            :
                            <button type="button" title="Send" className="send-reset-btn d-flex gap-1 align-items-center"
                                onClick={() => sendComment()}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M4.16602 9.99984H15.8327M15.8327 9.99984L9.99935 4.1665M15.8327 9.99984L9.99935 15.8332" stroke="#6941C6" strokeWidth="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>

                        }
                        {/* <CircularProgress 
                            size="md"
                            variant="solid"
                            value={
                                commentText.length ?
                                ((commentText.length/allowedChar) * 100).toFixed(0)
                                : 100
                            }
                        >
                            {(allowedChar - commentText.length)}
                        </CircularProgress> */}
                    </div>

                </form>
            </div>
        </div>
    )
}

export default DiscussCommentReplyComponent